export default "__VITE_ASSET__L4Z6JqXo__"